import React, { useState, useEffect, ReactNode } from "react";
import { Modal } from "react-bootstrap";
import "./css/ModalLinkButton.css";

interface ModalLinkButtonProps {
    Title?: string;
    modalTitle?: string;
    children: ReactNode;
    onOpenRequest?: () => void;
    onOpenComplete?: () => void;
    onCloseRequest?: () => void;
}

export const ModalLinkButton: React.FC<ModalLinkButtonProps> = ({
    Title,
    modalTitle,
    children,
    onOpenRequest,
    onOpenComplete,
    onCloseRequest
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        onOpenRequest?.();
        setIsOpen(true);
    };

    const closeModal = (goBack?: boolean | undefined) => {
        onCloseRequest?.();
        setIsOpen(false);
        if (goBack) {
            window.history.back();
        }
    };

    // Fire onOpenComplete after modal animation finishes
    useEffect(() => {
        if (isOpen && onOpenComplete) {
            const timer = setTimeout(() => {
                onOpenComplete();
            }, 150);
            return () => clearTimeout(timer);
        }
    }, [isOpen, onOpenComplete]);

    // Back-button closure support
    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const handlePop = () => {
            closeModal();
        };

        window.addEventListener("popstate", handlePop);
        window.history.pushState({ modal: true }, "");

        return () => {
            window.removeEventListener("popstate", handlePop);
        };
    }, [isOpen]);

    return (
        <>
            <a
                href="#"
                className={`modal-link-button${isOpen === true ? ' active' : ''} `}
                onClick={openModal}>
                {Title || "Open"}
            </a>

            <Modal
                show={isOpen}
                onHide={() => { closeModal(true); }}
                backdrop
                keyboard
                centered>

                <Modal.Header closeButton>
                    {modalTitle && (
                        <Modal.Title>{modalTitle}</Modal.Title>
                    )}
                </Modal.Header>

                <Modal.Body className="modal-link-body">
                    {children}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ModalLinkButton;
